module.exports = __webpack_public_path__ + "img/cpzljc.ebd875c5.png";